export default class FormOverlay {
  constructor (options) {
    this.element = options.element
    this.closeButton = this.element.querySelector('.close')
    this.remindMeLaterButton = document.querySelector('.remind-me-later span')

    this.closeButton.addEventListener('click', () => {
      this.element.classList.remove('visible')
      document.body.classList.remove('locked')
      this.remindMeLaterButton.classList.remove('hidden')
    })
  }
}



// WEBPACK FOOTER //
// ./components/form-overlay/index.js